import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import WorkingHours from "components/Dashboard/Dashboard_TotalWorkingHours";

const PERIODS = {
	WORKING_HOURS_WEEK: "week",
	WORKING_HOURS_MONTH: "month",
	WORKING_HOURS_YEAR: "year",
};

const Card_WorkingHoursPeriod = ({ name }) => {
	const { t } = useTranslation();
	const period = PERIODS[name];
	const periodLabel = {
		week: t("widgets.totalWorkingHours.thisWeek").toLowerCase(),
		month: moment().format("MMMM"),
		year: moment().format("YYYY"),
	}[period];

	return (
		<article className="card card-working-hours-period">
			<div className="card-top">
				<h2>{t("widgets.totalWorkingHours.workedHours")} {periodLabel}</h2>
			</div>
			<div className="card-content">
				<WorkingHours period={period} />
			</div>
		</article>
	);
};

export default Card_WorkingHoursPeriod;
